// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'
import 'element-ui/lib/theme-chalk/index.css';

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

import { Collapse, CollapseItem, Image, Icon, Card, Table, TableColumn } from 'element-ui';

Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Image);
Vue.use(Icon);
Vue.use(Card);
Vue.use(Table);
Vue.use(TableColumn);

// import VueI18n from 'vue-i18n'
// Vue.use(VueI18n)
//
// const i18n = VueI18n.createI18n({
//   locale: 'en', // set locale
//   fallbackLocale: 'en', // set fallback locale
//   messages: {
//     'en':require('./assets/language/en'), //英文语言包
//     'zh':require('./assets/language/zh'), //中文繁体包
//   }
// })

import store from './store'
import Ca from "element-ui/src/locale/lang/ca";

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js